import moment from 'moment';

export const getZonedDateAsMidnightUTC = (date: string, timezone: string): string => {
    const zonedDate = moment.tz(date, timezone);
    const interpretedTimestamp = moment.utc({
        year: zonedDate.year(),
        month: zonedDate.month(),
        date: zonedDate.date()
    });

    return interpretedTimestamp.toISOString();
};



// WEBPACK FOOTER //
// ./src/utils/date-transformation.ts